import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/nova/theme.css";
import React from "react";
import ReactDOM from "react-dom";
import "react-notifications/lib/notifications.css";
import App from "./App";
import "./css/collapsible.css";
import "./css/izvestaj.css";
import "./css/multiWrapper.css";
import "./fontawesome/css/all.css";
import "./index.css";
import "./main.css";
import * as serviceWorker from "./serviceWorker";
import { EnumRegisterName } from "./utils/EnumRegisterName";

let faviconPath = process.env.PUBLIC_URL + "/logo.png";
if (process.env.REACT_APP_REGISTER_NAME === EnumRegisterName.HAE) {
  faviconPath = process.env.PUBLIC_URL + "/deep.png";
  document.title = "DEEP";
  import("./css/layout/deep_layout.scss"!);
} else {
  import("./css/layout/layout.scss"!);
  document.title = "Regix";
}

const link = document.querySelector("link[rel='icon']");
if (link) {
  link.setAttribute("href", faviconPath);
} else {
  const newLink = document.createElement("link");
  newLink.setAttribute("rel", "icon");
  newLink.setAttribute("href", faviconPath);
  document.head.appendChild(newLink);
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
